import React, { Component } from "react";
import { Grid, Popover, OverlayTrigger } from "react-bootstrap";
import { NavLink } from "react-router-dom";

class Footer extends Component {

  render() {
    
    let submenu = (
      <Popover title="Estudios" id="estudios">
        <div><NavLink to="/diseño_grafico" style={{fontSize:13}}>DISEÑO GRÁFICO</NavLink></div>
        <div><NavLink to="/diseño_interior" style={{fontSize:13}}>DISEÑO INTERIOR</NavLink></div>
        <div><NavLink to="/diseño_moda" style={{fontSize:13}}>DISEÑO DE MODA</NavLink></div>
        <div><NavLink to="/publicidad_mercadeo" style={{fontSize:13}}>PUBLICIDAD Y MERCADEO</NavLink></div>
      </Popover>
    )

    return (
      <footer className="footer" style={{padding: 0,}}>
        <Grid fluid>
          <nav className="pull-left">
            <ul>
              {/* <li className="link-a">
                <NavLink to="/institucion">La Institución</NavLink>
              </li> */}
              <li>
                <NavLink to="/ingreso">Conócenos</NavLink>
              </li>
              <li>
                {/* <NavLink to="/estudios">Estudios</NavLink> */}
                <OverlayTrigger trigger="focus" placement="top" overlay={submenu}>
                  <button id="register" style={{
                    borderWidth:1,
                    backgroundColor: "rgba(0,0,0,0)",
                    color: "#FFF",
                    border:0,
                    outline:"none",
                    marginTop: 19,
                  }}>Servicio <i className="fa fa-caret-up"></i></button>
                </OverlayTrigger>
              </li>
              <li>
                <NavLink to="/extension">Planes Especiales</NavLink>
              </li>
            </ul>
          </nav>
          <p className="copyright pull-right" style={{color:"FFF"}}>
            &copy; {new Date().getFullYear()} Diseñado y Desarrollado por <a href = "https://www.eyss.io">
              <span style = {{color:"#4885ed"}}>E</span>
              <span style = {{color:"#dc3d36"}}>Y</span>
              <span style = {{color:"#f4c230"}}>S</span>
              <span style = {{color:"#62bc55"}}>S</span>
            </a>
          </p>
        </Grid>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx